export function validateEmpty(dataObj) {
    var returnValue = true;
    $.each(dataObj, function (key, value) {
        if (value === "") {
            returnValue = false;
        }
    });
    return returnValue;
}
